function StatusPill({ configured }) {
  return <span className={`admin-email-status ${configured ? 'is-ready' : 'is-missing'}`}>{configured ? 'Configured' : 'Missing env'}</span>;
}

function EmailSetupNote({ settings }) {
  const setup = settings?.setup || {};
  const domains = setup.domains || [];
  const receivingAddresses = setup.receivingAddresses?.length
    ? setup.receivingAddresses
    : ['hr@factorstreet.com', 'admin@factorstreet.com', 'hello@factorstreet.com'];

  return (
    <div className="admin-email-setup">
      <h2>Resend setup</h2>
      <div className="admin-email-setup__row">
        <span>Sending</span>
        <StatusPill configured={setup.sendingConfigured} />
      </div>
      <div className="admin-email-setup__row">
        <span>Webhook secret</span>
        <StatusPill configured={setup.webhookSecretConfigured} />
      </div>
      <div className="admin-email-setup__row">
        <span>Webhook path</span>
        <code>{setup.resendWebhookPath || '/api/webhooks/resend/inbound'}</code>
      </div>
      <div className="admin-email-setup__block">
        <span>Receiving addresses</span>
        <div>
          {receivingAddresses.map((address) => (
            <code key={address}>{address}</code>
          ))}
        </div>
      </div>
      {domains.length ? (
        <div className="admin-email-setup__block">
          <span>Domains</span>
          <div>
            {domains.map((domain) => (
              <div className="admin-email-setup-domain" key={domain.domain}>
                <div className="admin-email-setup__row">
                  <strong>{domain.domain}</strong>
                  <StatusPill configured={domain.configured} />
                </div>
                {domain.mailboxes?.map((mailbox) => (
                  <span className="admin-email-setup-mailbox" key={mailbox.address}>
                    <code>{mailbox.address}</code>
                    <StatusPill configured={mailbox.configured} />
                  </span>
                ))}
                {domain.missingEnv?.length ? (
                  <p>Missing env: {domain.missingEnv.join(', ')}</p>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      ) : null}
      <div className="admin-email-setup__row">
        <span>Default CC</span>
        <code>{settings?.defaultCc || 'None'}</code>
      </div>
      <p>{setup.receivingStatus || 'Ready after Resend DNS + webhook are configured'}</p>
    </div>
  );
}

export default EmailSetupNote;
